import { GameEngines, IGameRule, ISpecialRule } from ".";
import { BalanceInvalidReasons } from "./balval";
import { GameSystems } from "./gameSystems";
import { IDataSpecialRule } from "./rules";
import { ISpell } from "./spells";
import { IUnit } from "./units";
import { IUpgradePackage } from "./upgrades";
import { IWeapon } from "./weapons";

export enum ArmyBookVisibility {
  Private,
  Public,
  ShareOnly
}

export interface IArmyBook {
  uid: string;
  name: string;
  genericName?: string;
  versionString: string;
  coverImagePath: string;
  bannerImagePath: string;
  isLive: boolean;
  official: boolean;
  enabledGameSystems: number[];
  units: IUnit[];
  upgradePackages: IUpgradePackage[];
  specialRules: ISpecialRule[];
  spells: ISpell[];
  background: string;
  fullBackground: string;
  partnerSettings: any;
  customRules: IDataSpecialRule[];
  factionId: string;
  factionName: string;
  factionNameGeneric?: string;
  factionRelation: string;
  transforms: any[];
  alerts: any[];
  gameSystemId: number;
  bannedAt: string;
  username: string;
  gameSystemSlug: string;
  universe: string;
  aberration: string; // TODO: Rename to abbreviation lol
  flavouredUid: string;
  customWeapons: IWeapon[];
  balanceValid: boolean;
  balanceValidReason: BalanceInvalidReasons;
  editedAt?: string;
  visibility?: ArmyBookVisibility;
  loreUrl: string;
  userId: string;
  compiled?: boolean;
  usedRulesInSpells?: string[];
  raceGroup?: string;
  manualUnitSorting: boolean;
  gameEngine: GameEngines;
}

// TODO: Why are there two?
export interface IArmyData {
  uid: string;
  userId: string;
  flavouredUid: string;
  name: string;
  genericName: string;
  enabledGameSystems: number[];
  gameSystemId: number;
  factionName: string;
  factionNameGeneric: string;
  factionRelation: string;
  versionString: string;
  units: IUnit[];
  upgradePackages: IUpgradePackage[];
  specialRules: IGameRule[];
  spells: ISpell[];
  official: boolean;
  coverImagePath: string | null;
  bannerImagePath: string | null;
  username?: string;
  editedAt: string;
  isCreator: boolean;
  balanceValid: boolean;
  balanceValidReason: BalanceInvalidReasons;
  background: string;
  backgroundFull: string;
  popularity: number;
  downvotes: number;
  voted: null | "up" | "down";
  partnerSettings?: {
    images: string[];
    storeLinks: string[];
  };
  loreUrl: string;
  usedRulesInSpells?: string[];
  raceGroup?: string;
  manualUnitSorting: boolean;
}

export interface IArmyBookListItem {
  uid: string;
  name: string;
  genericName: string;
  unitCount: number;
  username?: string;
  editedAt: string;
  isCreator: boolean;
  balanceValidReason: BalanceInvalidReasons;
  popularity: number;
  downvotes: number;
  raceGroup?: string;
}

export interface IArmyBookOverview {
  uid: string;
  name: string;
  enabledGameSystems: GameSystems[];
  bannedAt: string;
  unitCount: number;
  upgradePackageCount: number;
  customRulesCount: number;
  spellCount: number;
  editedAt: string;
  official: boolean;
  visibility: ArmyBookVisibility;
  versionString: string;
  coverImagePath: string;
  factionId: string;
  factionName: string;
  factionRelation: string;
  balanceValid: boolean;
  balanceValidReason: BalanceInvalidReasons;
  popularity: number;
  alertCount: number;
  username: string;
}

export type BookInfo = {
  uid: string;
  name: string;
  genericName: string;
  versionString: string;
  official: boolean;
  enabledGameSystems: number[];
  visibility: ArmyBookVisibility;
  background: string;
  fullBackground: string;
  coverImagePath: string;
  bannerImagePath: string;
  partnerSettings: Record<string, any>;
  factionName: string;
  factionRelation: string;
  factionNameGeneric: string;
  factionId: string;
  loreUrl: string;
  editedAt: string;
  raceGroup: string;
  gameEngine: GameEngines;
  manualUnitSorting: boolean;
};

export type GenericallyNamed = {
  name: string;
  factionName?: string;
  factionNameGeneric?: string;
  genericName?: string;
};
